var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(12 12)",
    fill: "#F9EDD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8738 21.7886C26.8738 24.1192 25.748 25.5018 24.0099 25.5018C22.1335 25.5018 21.0472 24.1785 21.0472 21.7886C21.0472 19.2209 22.0742 17.8976 23.9506 17.8976C25.827 17.8976 26.8935 19.2407 26.8738 21.7886ZM17.5907 33.0073H21.0274V26.4104C21.8965 27.7139 23.2593 28.3855 24.9579 28.3855C28.0589 28.3855 30.4093 25.7586 30.4093 21.6306C30.4093 17.6211 28.1181 14.9941 24.9184 14.9941C23.2001 14.9941 21.9952 15.6657 20.9682 17.1273V15.4287H17.5907V33.0073Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofpoint);
export default __webpack_public_path__ + "static/media/Proofpoint.e349676b26cb77160ca7f024a2f61aa3.svg";
export { ForwardRef as ReactComponent };